import { InvoiceDiscountMode } from '@features/invoices/enums/invoiceDiscountMode'
import { InvoiceLineColumn } from '@features/invoices/types/invoiceLineColumn'

import {
  DEMO_INVOICE_VISIBLE_COLUMNS,
  DEMO_INVOICE_VISIBLE_COLUMNS_WITH_DISCOUNT,
} from '../constants/demoInvoiceVisibleColumns'

export const getDemoInvoiceVisibleColumns = (discountMode: InvoiceDiscountMode): InvoiceLineColumn[] =>
  discountMode === InvoiceDiscountMode.ByItem
    ? DEMO_INVOICE_VISIBLE_COLUMNS_WITH_DISCOUNT
    : DEMO_INVOICE_VISIBLE_COLUMNS
